import { Button, Popover, Radio, Row } from 'antd';
import styled from 'styled-components';

const ContentButtonsChangeCalendar = styled.div`
  display: flex;
`;

const ButtonViewEvents = styled(Button)`
  border: none;
  box-shadow: none;
  padding-right: 0px;
  padding-left: 0px;
  color: #858ead;
`;

const PopoverChanegView = styled(Popover)`
  span {
    background-color: transparent;
  }
`;

const ContentPopover = styled.div`
  width: 150px;
`;

const StyledRadios = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ButtonChangeMode = styled(Button)`
  color: ${(props) => (props.isActive ? '#F04D00' : '#59607C')};
  border: ${(props) => (props.isActive ? '1px solid #F04D00' : '1px solid #E3E6EE')};
`;

const ButtonConfirm = styled(Button)`
  background-color: ${(props) => (props.confirm ? '#81D7A7' : '#01AF50')};
  color: white;
  &&:hover {
    background-color: ${(props) => props.confirm ?? '#81d7a7'};
    color: ${(props) => props.confirm ?? 'white'};
    border: ${(props) => props.confirm ?? 'white'};
  }
`;

const ContentAppointmentConfirm = styled.div`
  width: 25%;
  min-width: 200px;
  margin: 0 0 20px 0;
  background-color: ${(props) => (props.confirm ? '#B4E5A1' : '#D9D9D9')};
  color: ${(props) => (props.confirm ? '#01AF50' : 'black')};
  justify-content: center;
  text-align: center;
  border-radius: 20px;
  min-height: 25px;
  align-content: center;
`;

const StyledStatusPayment = styled.span`
  ${({ status }) => {
    return `
      color: ${status};
      background-color: ${`${status}40`};
      padding: 4px 15px;
      border-radius: 10px;
      font-size: 13px !important;
    `;
  }};
`;

const ContentMobileFormDetails = styled(Row)`
  margin-top: 20px;
  padding: 5px 20px 20px;
`;

export {
  ContentButtonsChangeCalendar,
  ButtonViewEvents,
  PopoverChanegView,
  ContentPopover,
  StyledRadios,
  ButtonChangeMode,
  ButtonConfirm,
  ContentAppointmentConfirm,
  StyledStatusPayment,
  ContentMobileFormDetails,
};
